import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface PageActionsProps {
  mobileMarginTop?: boolean;
  display?: 'row' | 'column';
  align?: 'end';
}

const PageActions = styled.section<PageActionsProps>`
  position: relative;
  display: flex;
  flex-flow: nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow-y: visible;

  @media (min-width: ${theme.breakpoint.small}px) {
    padding-left: ${toRem(theme.space.xl)};
  }

  > * {
    margin-left: ${toRem(theme.space.md)};

    &:first-child {
      margin-left: 0;
    }
  }

  ${({ display }) =>
    display === 'column' &&
    css`
      flex-flow: column nowrap;
    `}

  ${({ align }) =>
    align === 'end' &&
    css`
      align-items: end;

      @media (max-width: ${theme.breakpoint.small}px) {
        align-items: center;
      }
    `}


  ${({ mobileMarginTop: hasMobileMarginTop }) =>
    hasMobileMarginTop &&
    css`
      margin-top: ${toRem(theme.space.md)};

      @media (min-width: ${theme.breakpoint.small}px) {
        margin-top: 0;
      }
    `}

   label {
    color: ${theme.color.neutral[400]};
  }

  h2 {
    color: ${theme.color.white};
    font-family: ${theme.font.family.averta};
    font-weight: ${theme.font.weight.regular};
    font-size: clamp(${toRem(theme.font.size['2xl'])}, 5vw, ${toRem(theme.font.size['6xl'])});
  }

  span.react-loading-skeleton {
    background-color: ${theme.color.neutral[700]};
    background-image: linear-gradient(90deg, ${theme.color.neutral[800]}, ${theme.color.neutral[700]}, ${theme.color.neutral[800]}) !important;
  }
`;

export default PageActions;
